<app-phone-number [number]="office.fax" [linkTo]="linkTo" [allowCopyToClipboard]="true" />
@if (canViewOffice) {
  <a target="_blank" href="/capture-admin/offices/{{ office.id }}">
    <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
  </a>
}

